import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import Loader from "../components/Loader/Loader";
import ROUTES from "../constants/routes";
import { useEffect } from "react";
import { storage } from "./storage";

const ProtectedRoutes = ({loading}) => {
  const user  = useSelector((state) => state.userReducer.value);
  const location = useLocation();

  const gotoPath = location.pathname + location.search;

  if(!user.id){
    storage.set("gotoPath", gotoPath);
  }

  return loading ? <Loader/> : user.id ? <Outlet /> : <Navigate to={ROUTES.login.path} replace />;
};

export default ProtectedRoutes;
